import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Attach bearer token from the "admin" auth record on every request.
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("saarthi_admin");
    if (raw) {
      const { access_token } = JSON.parse(raw);
      if (access_token) config.headers.Authorization = `Bearer ${access_token}`;
    }
  } catch {
    /* ignore malformed storage */
  }
  return config;
});

/**
 * Extract a human-readable error message from an axios error.
 * Backend returns { success: false, message } for all errors.
 */
export function pickErr(err, fallback = "Something went wrong") {
  const body = err?.response?.data;
  if (body && typeof body === "object") {
    if (typeof body.message === "string" && body.message) return body.message;
    if (typeof body.detail === "string") return body.detail;
  }
  return err?.message || fallback;
}

export { API_BASE };
export default api;
